let scrollBehaviorSupported;

export function isScrollBehaviorSupported() {
  if (scrollBehaviorSupported === undefined) {
    scrollBehaviorSupported = "scrollBehavior" in document.documentElement.style;
  }

  return scrollBehaviorSupported;
}
